import { Link } from "react-router-dom";

export default function HospitalHero() {
  return (
    <section className="relative w-full h-[90vh] min-h-[600px] overflow-hidden">
      <img
        src="/images/hospital/pharmacy-counter.webp"
        alt="Hospital & Pharmacy Equipment"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>

      <div className="absolute inset-0 flex flex-col justify-center px-6 md:px-16 max-w-7xl mx-auto w-full">
        <span className="inline-block text-teal-400 text-xs font-bold uppercase tracking-widest mb-4">
          Healthcare Fabrication Specialists
        </span>
        <h1 className="text-white text-4xl md:text-6xl font-extrabold leading-tight max-w-3xl uppercase tracking-tight">
          Hospital &amp; Pharmacy<br />
          <span className="text-teal-400">Equipment</span> Solutions
        </h1>
        <p className="text-white/70 text-base md:text-lg mt-6 max-w-xl leading-relaxed">
          Custom-fabricated stainless steel medical cabinets, pharmacy counters,
          dispensary units, and sterile storage — built to healthcare-grade standards
          and installed across Kenya's leading hospitals and clinics.
        </p>

        {/* Stats row */}
        <div className="flex flex-wrap gap-8 mt-10">
          {[
            { value: "200+", label: "Healthcare Installs" },
            { value: "15+", label: "Years Experience" },
            { value: "100%", label: "SS304 / SS316 Grade" },
            { value: "48hr", label: "Site Survey Response" },
          ].map((stat) => (
            <div key={stat.label}>
              <p className="text-teal-400 text-3xl font-extrabold">{stat.value}</p>
              <p className="text-white/60 text-xs uppercase tracking-wider mt-1">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-4 mt-10">
          <a
            href="#inquiry"
            onClick={(e) => { e.preventDefault(); document.querySelector("#inquiry")?.scrollIntoView({ behavior: "smooth" }); }}
            className="bg-teal-600 hover:bg-teal-500 text-white font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap"
          >
            Request a Quote
          </a>
          <a
            href="#products"
            onClick={(e) => { e.preventDefault(); document.querySelector("#products")?.scrollIntoView({ behavior: "smooth" }); }}
            className="bg-white/10 hover:bg-white/20 border border-white/30 text-white font-bold px-8 py-3 rounded-md uppercase text-sm tracking-wider transition-colors cursor-pointer whitespace-nowrap"
          >
            View Products
          </a>
        </div>
      </div>
    </section>
  );
}
